<template>
  <header class="bg-white dark:bg-neutral-900 overflow-x-hidden mb-4 lg:mb-6">
    <PageBanner :src="bannerUrl" :blur :loading="pending" />
    <div class="px-4 lg:px-8 space-y-4">
      <div class="container">
        <slot></slot>
      </div>
      <div v-if="currentTab !== undefined && paths" class="container">
        <Tabs v-model="currentTab" :tabs="paths" no-emit />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts" generic="T extends string">
import type { PageTab } from "~/types/navigation";

defineProps<{
  bannerUrl?: string;
  blur?: boolean;
  paths?: PageTab<T>[];
  pending?: boolean;
}>();

const currentTab = defineModel<T>("currentTab");
</script>
